import { render, staticRenderFns } from "./ResidentsPage.vue?vue&type=template&id=3dfe9377&"
import script from "./ResidentsPage.vue?vue&type=script&lang=js&"
export * from "./ResidentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dfe9377')) {
      api.createRecord('3dfe9377', component.options)
    } else {
      api.reload('3dfe9377', component.options)
    }
    module.hot.accept("./ResidentsPage.vue?vue&type=template&id=3dfe9377&", function () {
      api.rerender('3dfe9377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/ResidentsPage.vue"
export default component.exports